var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"topo-page"}},[_c('iframe',{attrs:{"id":"topo-frame","src":"/topo3d/topo-3d.html","frameborder":"0","allowfullscreen":""}}),_c('button',{staticClass:"back-btn",on:{"click":_vm.goBack}},[_vm._v("⬅ 返回大屏")])])
}
var staticRenderFns = []

export { render, staticRenderFns }